import { combineReducers } from 'redux'
import ACTIONS from "./auth/AuthActions";
import storage from 'redux-persist/lib/storage';

// REDUCERS IMPORTS
import veritasRootReducer from "./veritas/VeritasRootReducers";
import marvelRootReducer from "./common/marvel-reducers/MarvelRootReducer";
import supportRootReducers from "./support/SupportRootReducers";
import reportGenRootReducer from "./report-generation/ReportGenRootReducer";
import billingRootReducer from "./billing/BillingRootReducer";
import routerReducer from "./router/RouterReducer";

const appReducer = combineReducers({
    veritas: veritasRootReducer,
    marvel: marvelRootReducer,
    support: supportRootReducers,
    report: reportGenRootReducer,
    billing: billingRootReducer,
    router: routerReducer,
});

const rootReducer = (state, action) => {
    if (action.type === ACTIONS.Types.SIGN_OUT) {
        // for all keys defined in your persistConfig(s)
        storage.removeItem('persist:root')
        // storage.removeItem('persist:otherKey')
        state = undefined;
    }
    return appReducer(state, action);
};

export default rootReducer;
